module.exports = __webpack_public_path__ + "static/img/tiget-b.eee06d17.jpg";